/**
 * 告警规则。判定跑在 hub 里(fleetstate/rules.go),阈值是编译期常量 ——
 * 所以这一页现在是**只读**的:把真正生效的规则说清楚,而不是给几个改不动的开关。
 */
import { NoDataSource } from '@/components/feature/DataSource';

const RULES = [
  { kind: '设备掉线', when: '注册表 last_seen 超过 5 分钟且私有网也看不到它', level: '警告',
    note: '**从未接入过的设备不判掉线** —— 那是等待首次接入,不是故障' },
  { kind: '电量偏低', when: '上报电量 ≤ 20%(≤ 10% 升为严重)', level: '警告 / 严重',
    note: '**没上报电量的设备不会触发** —— 未知不等于危急' },
  { kind: '温度偏高', when: '上报温度 ≥ 70℃(≥ 80℃ 升为严重)', level: '警告 / 严重',
    note: 'Jetson 到 80℃ 开始降频' },
];

export default function AlertRules() {
  return (
    <>
      <div className="mb-4">
        <h3 className="text-xs font-bold text-foreground-800 mb-1">当前生效的判定规则</h3>
        <p className="text-[11px] text-foreground-400">hub 每 10 秒判定一轮。同一条件重复只累加次数,条件消失自动消解。</p>
      </div>
      <div className="space-y-2">
        {RULES.map((r) => (
          <div key={r.kind} className="bg-background-100 rounded-lg p-3">
            <div className="flex items-center gap-2 mb-1">
              <span className="text-xs font-bold text-foreground-800">{r.kind}</span>
              <span className="text-[10px] px-1.5 py-0.5 rounded bg-amber-50 text-amber-700">{r.level}</span>
            </div>
            <p className="text-[11px] text-foreground-600">触发:{r.when}</p>
            <p className="text-[10px] text-foreground-400 mt-0.5">{r.note}</p>
          </div>
        ))}
      </div>
      <div className="mt-4 bg-background-50 border border-background-200/70 rounded-lg">
        <NoDataSource
          title="阈值暂不可在线修改"
          reason="阈值现在是 hub 里的常量(fleetstate.DefaultThresholds)。做成可配要多一张规则表和一份下发路径 —— 在那之前,给几个点了不生效的开关不如说清楚现状。"
          phase="P2 · 规则表 + 每设备覆盖"
        />
      </div>
    </>
  );
}
